import React from "react";

export const Tabs = ({ tabs, children, selected, setSelected }) => {
  return (
    <div className="tle_tabs">
      <div className="tle_tabs_container">
        {tabs.map((tab, i) => (
          <button
            className={`tle_tabs_tab ${i === selected ? "selected" : ""}`}
            key={tab.title}
            onClick={() => setSelected(i)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className="tle_tabs_sections">
        {children?.map((section, i) => (i === selected ? section : null))}
      </div>
    </div>
  );
};
